/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";

// Lazy load route components - each becomes its own chunk
const App = lazy(() => import("./App"));
const SlidesRouter = lazy(() =>
  import("./slides").then((m) => ({ default: m.SlidesRouter }))
);

const elem = document.getElementById("root")!;

// Simple path-based routing
const path = window.location.pathname;
const isSlides = path.startsWith("/slides");

function LoadingFallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#1a1a1a",
        color: "#93a1a1",
      }}
    >
      Loading...
    </div>
  );
}

const app = (
  <StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      {isSlides ? <SlidesRouter /> : <App />}
    </Suspense>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
